import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ServicesModule } from 'src/services/services.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';
import { AuthenticationModule } from './authentication/authentication.module';
import { BaseComponent } from './base/base.component';
import { HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './main/home/home.component';
import { MainModule } from './main/main.module';
import { LayoutsModule } from './layouts/layouts.module';
import { AccountModule } from './account/account.module';
import { NgbModule, NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { ProductModule } from './product/product.module';
import { SellerModule } from './seller/seller.module';
import { OrderModule } from './order/order.module';
import { CategoriesModule } from './categories/categories.module';
import { InvitesModule } from './invites/invites.module';
import { ReviewsModule } from './reviews/reviews.module';
import { PaymentModule } from './payment/payment.module';
import { HelpersModule } from 'src/infrastructure/helpers/helpers.module';
import { RoutingHelpers } from 'src/infrastructure/helpers/RoutingHelpers';
import { HistoryBaseComponent } from './history-base/history-base.component';
import { ReturnsComponent } from './returns/returns/returns/returns.component';
import { ChooseReturnComponent } from './returnflow/choose-return/choose-return.component';
import { ReturnReasonComponent } from './returnflow/return-reason/return-reason.component';
import { ReturnUserDataComponent } from './returnflow/return-user-data/return-user-data.component';
import { ReturnInfoComponent } from './returnflow/return-info/return-info.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ReturnCompletedComponent } from './returnflow/return-completed/return-completed.component';
import { ReturnComponent } from './returns/returns/return/return.component';
import { CreateGroupComponent } from './groups/create-group/create-group.component';
import { GroupCompletedComponent } from './groups/group-completed/group-completed.component';
import { JoinGroupComponent } from './groups/join-group/join-group.component';
import { JoinCompletedComponent } from './groups/join-completed/join-completed.component';
import { RedirectComponent } from './redirect/redirect.component';
import { createErrorHandler } from '@sentry/angular';
import {AppCommonModule} from "./common/common.module";

@NgModule({
  declarations: [
    AppComponent,
    BaseComponent,
    HistoryBaseComponent,
    ReturnsComponent,
    ChooseReturnComponent,
    ReturnReasonComponent,
    ReturnUserDataComponent,
    ReturnInfoComponent,
    ReturnCompletedComponent,
    ReturnComponent,
    CreateGroupComponent,
    GroupCompletedComponent,
    JoinGroupComponent,
    JoinCompletedComponent,
    RedirectComponent
  ],
  imports: [
    AuthenticationModule,
    MainModule,
    BrowserModule,
    AppRoutingModule,
    ServicesModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    LayoutsModule,
    AccountModule,
    NgbModule,
    ProductModule,
    NgbRatingModule,
    SellerModule,
    OrderModule,
    CategoriesModule,
    InvitesModule,
    ReviewsModule,
    PaymentModule,
    HelpersModule,
    ReactiveFormsModule,
    AppCommonModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: createErrorHandler({
        showDialog: false,
      }),
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
